export const certificates = [
  {
    label: "Certified Family Support Specialist",
    validUpto: "26 July 2022",
    renew: true,
    type: "cfss",
  },
  {
    label: "Certified Young Adult Peer Support Specialist",
    validUpto: "26 March 2023",
    renew: false,
    type: "cyapss",
  },
];

export const educationCertificate = [
  {
    title: "Building Resilient Families",
    programTitle: "Strategies for Family Support Specialists",
    description:
      "Learn effective strategies to help families facing various challenges build resilience and overcome adversity.",
    date: "26 March 2023",
    isCertificate: true,
  },
  {
    title: "Building Resilient Families",
    programTitle: "Strategies for Family Support Specialists",
    description:
      "Learn effective strategies to help families facing various challenges build resilience and overcome adversity.",
    date: "26 March 2023",
    isCertificate: true,
  },
];
